/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * List of device roles in dm_dc relations
 */
export type DeviceRelationRole = (typeof DeviceRelationRole)[keyof typeof DeviceRelationRole];

export const DeviceRelationRole = {
  DC: 'dc',
  DM: 'dm',
} as const;
